module.exports = __webpack_public_path__ + "img/A高通锐化5.2663103e.png";